import { render, staticRenderFns } from "./ModalEntregaDocumento.vue?vue&type=template&id=37623876"
import script from "./ModalEntregaDocumento.vue?vue&type=script&lang=js"
export * from "./ModalEntregaDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37623876')) {
      api.createRecord('37623876', component.options)
    } else {
      api.reload('37623876', component.options)
    }
    module.hot.accept("./ModalEntregaDocumento.vue?vue&type=template&id=37623876", function () {
      api.rerender('37623876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/infoBase/modales/ModalEntregaDocumento.vue"
export default component.exports